import { render, staticRenderFns } from "./HazardousAreaList.vue?vue&type=template&id=31e9d0a4&scoped=true&"
import script from "./HazardousAreaList.vue?vue&type=script&lang=js&"
export * from "./HazardousAreaList.vue?vue&type=script&lang=js&"
import style0 from "./HazardousAreaList.vue?vue&type=style&index=0&id=31e9d0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e9d0a4",
  null
  
)

export default component.exports